import * as z from "zod/v4";

export const deletePaymentMethod = {
  name: "deletePaymentMethod" as const,
  input: z.object({ primary: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
